export const formatDate = (date: number) => {
    const MONTH_NAME = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    const newDate = new Date(new Date(date).toUTCString())
    const findMont = MONTH_NAME[newDate.getMonth()]
    return `${findMont} ${newDate.getDate()}, ${newDate.getFullYear()}`
}

export const formatDateV2 = (date: number | string, hiddenDayMonth?: boolean) => {
    const MONTH_NAME = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    const hourUTC = new Date(new Date(date)).getUTCHours()
    const minusUTC = new Date(new Date(date)).getUTCMinutes()
    const dateUTC = new Date(new Date(date)).getUTCDate()
    const monthUTC = MONTH_NAME[new Date(new Date(date)).getUTCMonth().toString()]
    const renderHourUTC = hourUTC < 10 ? `0${hourUTC}` : `${hourUTC}`
    const renderMinusUTC = minusUTC < 10 ? `:0${minusUTC}` : `:${minusUTC}`
    return `${monthUTC} ${dateUTC}, ${renderHourUTC}${renderMinusUTC}`
}

export const formatDateV3 = (date: number | string) => {
    const MONTH_NAME = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    const hourUTC = new Date(new Date(date)).getUTCHours()
    const minusUTC = new Date(new Date(date)).getUTCMinutes()
    const dateUTC = new Date(new Date(date)).getUTCDate()
    const year = new Date(new Date(date)).getFullYear()
    const second = new Date(new Date(date)).getUTCSeconds()
    const monthUTC = MONTH_NAME[new Date(new Date(date)).getUTCMonth().toString()]
    const renderHourUTC = hourUTC < 10 ? `0${hourUTC}` : `${hourUTC}`
    const renderMinusUTC = minusUTC < 10 ? `:0${minusUTC}` : `:${minusUTC}`
    const renderSecondsUTC = second < 10 ? `:0${second}` : `:${second}`
    return `${dateUTC} ${monthUTC} ${year} ${renderHourUTC}${renderMinusUTC}${renderSecondsUTC} UTC`
}
